"use strict";
function setBuildEpochFromHeaders(response) {
  const buildEpoch = response.headers.get("x-caprx-build-count");
  if (!buildEpoch) return;
  const hostGlobal = globalThis;
  hostGlobal.__CAPRX_BUILD_EPOCH__ = buildEpoch;
}
function emitManifestFetchDiagnostic(set, status, message) {
  if (typeof window === "undefined") return;
  const hostGlobal = globalThis;
  globalThis.dispatchEvent(
    new CustomEvent("caprx:shell-module-diagnostic", {
      detail: {
        set,
        stage: "manifest-fetch",
        status,
        message,
        buildEpoch: hostGlobal.__CAPRX_BUILD_EPOCH__,
        timestamp: (/* @__PURE__ */ new Date()).toISOString()
      }
    })
  );
}
function replacePath(path) {
  const { protocol, hostname } = globalThis.location;
  return path.replace("{{protocol}}", protocol).replace("{{hostname}}", hostname);
}
function deriveScope(id) {
  return id.split("-").join("_");
}
function createLegacyModuleDescriptor(id, modulePath) {
  const resolved = replacePath(modulePath);
  const basePath = resolved.replace(/[^/]*$/, "");
  return {
    id,
    metadataPath: `${basePath}metadata.json`,
    federation: {
      remoteEntry: `${basePath}remoteEntry.js`,
      scope: deriveScope(id)
    }
  };
}
function createModuleDescriptor(id, entry) {
  if (typeof entry === "string") {
    return createLegacyModuleDescriptor(id, entry);
  }
  if (!entry.federation) {
    throw new Error(`Module [${id}] is missing federation configuration.`);
  }
  return {
    id,
    metadataPath: entry.metadataPath ? replacePath(entry.metadataPath) : void 0,
    federation: {
      remoteEntry: replacePath(entry.federation.remoteEntry),
      scope: entry.federation.scope || deriveScope(id),
      exposedModule: entry.federation.exposedModule
    }
  };
}
function parseManifestEntries(entries) {
  const descriptors = [];
  for (const [id, entry] of Object.entries(entries)) {
    if (typeof entry === "object" && entry !== null && entry.enabled === false) {
      continue;
    }
    try {
      descriptors.push(createModuleDescriptor(id, entry));
    } catch (err) {
      console.warn(`Skipping malformed module manifest entry [${id}].`, err);
    }
  }
  return descriptors;
}
export async function fetchAvailableModules(set) {
  try {
    emitManifestFetchDiagnostic(set, "start");
    const response = await fetch(`/modules/module_manifest.${set}.json`, {
      cache: "no-store"
    });
    setBuildEpochFromHeaders(response);
    if (!response.ok) {
      throw new Error(`Module manifest request for [${set}] failed with status ${response.status}.`);
    }
    const modules = await response.json();
    let descriptors = parseManifestEntries(modules);
    if (process.env.NODE_ENV === "development") {
      if (set === "app") {
        try {
          const devResponse = await fetch("/modules/module_manifest.dev.json", {
            cache: "no-store"
          });
          setBuildEpochFromHeaders(devResponse);
          const devModules = await devResponse.json();
          const userDescriptors = parseManifestEntries(devModules);
          descriptors = [...descriptors, ...userDescriptors];
        } catch {
        }
      }
    }
    emitManifestFetchDiagnostic(set, "success");
    return descriptors;
  } catch (err) {
    emitManifestFetchDiagnostic(set, "failure", "Unable to fetch list of available modules.");
    console.warn("Unable to fetch list of available modules!", err);
    return null;
  }
}
